
import { Box, Button, IconButton, Tooltip } from '@mui/material'
import styles from '../../../../pages/read-documents/styles/tableResults.module.scss'
import { useWidth } from 'shared/hooks/HookDetailedConsultation/useWidth'
import DownloadIcon from '@mui/icons-material/Download';
import { ITable } from 'shared/components/interfaces';
import Images from 'shared/assets/index';
import { SearchItems } from 'shared/components/paginator/SearchItems';
import { IRespDocuments, roles } from 'shared/models';
import { useAuth } from 'shared/auth';

interface IHeaderSearchProps {
    downloadExcel?: (() => void),
    uploadExcel?: (() => void),
    optionsTrazact?: ((id: string) => JSX.Element),
    getSectionClassName: () => string,
    isDisabledButtonTraza: boolean | undefined,
    buttonClassName: string
    startIconContent: JSX.Element | undefined,
    props: any
    contentSize: number,
    totalElements: number,
    idTable: string | undefined,
    content: IRespDocuments[] | null,
    widthSearchFull?: boolean
}

export const HeaderSearch = ({ buttonClassName, contentSize, downloadExcel, isDisabledButtonTraza, optionsTrazact, props, 
    startIconContent, totalElements, getSectionClassName, idTable, content, uploadExcel, widthSearchFull }: IHeaderSearchProps) => {
    const { width } = useWidth()
    const { authService } = useAuth();

    const userValidate = authService.getUserRoles().includes(roles.admin)
    return (
        <Box className={styles.searchContainer}>
            
        {
        width > 900 ?
            <section className={styles.contentButton}>
                {
                    downloadExcel &&
                    <Tooltip title='Exportar Facturas' placement="top" arrow>
                        <IconButton
                            className={styles.buttonExportExcel}
                            data-testid="btn-export"
                            onClick={downloadExcel}
                        >
                        <img className={styles.exportImage} src={Images.iconoDescargar} alt="Exportar a excel" />
                        </IconButton>
                    </Tooltip>
                }
                {
                    (uploadExcel && idTable === "table-facturas") && userValidate &&
                        <Tooltip title='Subir información de Pagos' placement="top" arrow>
                            <IconButton
                                className={styles.buttonImportExcel}
                                data-testid="btn-import"
                                onClick={uploadExcel}
                            >
                            <img className={styles.importImage} src={Images.iconoSubirArchivo} alt="Importar comprobantes" />
                            </IconButton>
                        </Tooltip>
                }
                { optionsTrazact && optionsTrazact?.(idTable ?? '') }
            </section>
        : 
        <section className={getSectionClassName()} data-testid='section-buttons-mobil'>
            {
            downloadExcel &&
                <Button onClick={downloadExcel} className={styles.buttons} data-testid="btn-export-mobil" startIcon={<DownloadIcon />}>
                Exportar Facturas
                </Button>
            }
            {
            optionsTrazact &&
                <Button disabled={isDisabledButtonTraza} data-testid="btn-mobil-traza"  className={buttonClassName} startIcon={startIconContent}>
                Asignar
                </Button>
            }
            {
                (uploadExcel && idTable === "table-facturas") && userValidate &&
                    <Button data-testid="btn-upload-traza" className={buttonClassName} onClick={uploadExcel}>
                        <img className={styles.importImage} src={Images.iconoSubirArchivo} alt="Importar comprobantes" />
                        Soportes de Pago
                    </Button>
            }
        </section>
        }
        <span className={`${styles.searchItems} ${widthSearchFull ? styles.searchFullWidth : ''} `} data-testid='search-items'>
            <SearchItems data={content!} placeholder='Buscar' autocomplete={false} />
        </span>
        
        
    </Box>
    )
}
